import { SerializableObject } from './serializable-object';

// TODO: Fid a way to remove or rename this class.
export class Primitive<T> extends SerializableObject {
  value: T;

  public buildFromJSON(json: any) {
    // in this case json is a primitive type
    this.value = json;
  }
}
